export const CLOSE_CIRCLE_RELATIONSHIPS = [
  { value: 'spouse', labelKey: 'CLOSE_CIRCLE.RELATIONSHIPS.SPOUSE' },
  { value: 'child', labelKey: 'CLOSE_CIRCLE.RELATIONSHIPS.CHILD' },
  { value: 'parent', labelKey: 'CLOSE_CIRCLE.RELATIONSHIPS.PARENT' },
  { value: 'friend', labelKey: 'CLOSE_CIRCLE.RELATIONSHIPS.FRIEND' },
  { value: 'assistant', labelKey: 'CLOSE_CIRCLE.RELATIONSHIPS.ASSISTANT' },
  { value: 'colleague', labelKey: 'CLOSE_CIRCLE.RELATIONSHIPS.COLLEAGUE' },
  { value: 'other', labelKey: 'CLOSE_CIRCLE.RELATIONSHIPS.OTHER' },
];

export const CLOSE_CIRCLE_DATE_TYPES = [
  { value: 'birthday', labelKey: 'CLOSE_CIRCLE.DATE_TYPES.BIRTHDAY' },
  {
    value: 'wedding_anniversary',
    labelKey: 'CLOSE_CIRCLE.DATE_TYPES.WEDDING_ANNIVERSARY',
  },
  { value: 'birth', labelKey: 'CLOSE_CIRCLE.DATE_TYPES.BIRTH' },
  { value: 'engagement', labelKey: 'CLOSE_CIRCLE.DATE_TYPES.ENGAGEMENT' },
  { value: 'other', labelKey: 'CLOSE_CIRCLE.DATE_TYPES.OTHER' },
];
